export const yodaStakeholderConstants = {
  GETALL_REQUEST: "YODASTAKEHOLDER_GETALL_REQUEST",
  GETALL_SUCCESS: "YODASTAKEHOLDER_GETALL_SUCCESS",
  GETALL_FAILURE: "YODASTAKEHOLDER_GETALL_FAILURE",

  GETME_REQUEST: "YODASTAKEHOLDER_GETME_REQUEST",
  GETME_SUCCESS: "YODASTAKEHOLDER_GETME_SUCCESS",
  GETME_FAILURE: "YODASTAKEHOLDER_GETME_FAILURE",

  GET_ORDER_HISTORY_REQUEST: "YODASTAKEHOLDER_GET_ORDER_HISTORY_REQUEST",
  GET_ORDER_HISTORY_SUCCESS: "YODASTAKEHOLDER_GET_ORDER_HISTORY_SUCCESS",
  GET_ORDER_HISTORY_FAILURE: "YODASTAKEHOLDER_GET_ORDER_HISTORY_FAILURE",

  ORDER_HISTORY_RESET: "YODASTAKEHOLDER_ORDER_HISTORY_RESET",

  GET_ORDER_HISTORY_NEW_COUNT_REQUEST:
    "YODASTAKEHOLDER_GET_ORDER_HISTORY_NEW_COUNT_REQUEST",
  GET_ORDER_HISTORY_NEW_COUNT_SUCCESS:
    "YODASTAKEHOLDER_GET_ORDER_HISTORY_NEW_COUNT_SUCCESS",
  GET_ORDER_HISTORY_NEW_COUNT_FAILURE:
    "YODASTAKEHOLDER_GET_ORDER_HISTORY_NEW_COUNT_FAILURE",

  RESET: "YODASTAKEHOLDER_RESET",
};
